"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepthImageFrame = void 0;
const tslib_1 = require("tslib");
const ImageFrame_1 = require("./ImageFrame");
const core_1 = require("@openhps/core");
let DepthImageFrame = class DepthImageFrame extends ImageFrame_1.ImageFrame {
};
exports.DepthImageFrame = DepthImageFrame;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Object)
], DepthImageFrame.prototype, "depth", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", core_1.LengthUnit)
], DepthImageFrame.prototype, "depthUnit", void 0);
exports.DepthImageFrame = DepthImageFrame = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], DepthImageFrame);
//# sourceMappingURL=DepthImageFrame.js.map